import { faAngleRight, faArrowRightArrowLeft, faBook, faGear, faHeart, faHome, faShieldHalved, faUser, faVihara } from "@fortawesome/free-solid-svg-icons";
import img1 from "../assets/images/card/1.png";
import img2 from "../assets/images/card/2.png";
import img3 from "../assets/images/card/3.png";
import img4 from "../assets/images/card/4.png";
import img5 from "../assets/images/card/5.png";
import property from "../assets/images/card/property.png";

import filterIcon from '../assets/images/filter/filter.svg'
import rupee from '../assets/images/filter/rupee.svg'
import star from '../assets/images/filter/star.svg'
import wifi from '../assets/images/filter/wifi.svg'

import logo from '../assets/images/logo/logoDark.png'


export const USER_SIDEBAR_ROUTES = [
  { name: "Profile Information", path: "/user/profile", icon: faUser },
  { name: "Whishlist", path: "/user/whishlist", icon: faHeart },
  { name: "Your Bookings", path: "/user/bookings", icon: faVihara },
  { name: "Terms of service", path: "/terms-of-service", icon: faBook },
  { name: "Privacy policy", path: "/privacy-policy", icon: faShieldHalved },
  { name: "Cookies policy", path: "/cookies-policy", icon: faArrowRightArrowLeft },
];



export const topDestinations = [
  {
    img: img1,
    destination: "Odisha",
    rating: 4 / 2,
  },
  {
    img: img2,
    destination: "Madhya Pradesh",
    rating: 4 / 2,
  },
  {
    img: img3,
    destination: "Uttarakhand",
    rating: 4 / 2,
  },
  {
    img: img4,
    destination: "Haryana",
    rating: 4 / 2,
  },

  {
    img: img5,
    destination: "Uttar Pradesh",
    rating: 4 / 2,
  },
  {
    img: img1,
    destination: "Naga Land",
    rating: 4 / 2,
  },
];


export const properties = [
  {
    "id": 1,
    "name": "The Fern Residency, Noida",
    "image": property,
    "description": "Visit the temples and the Chiang Mai Night Bazaar, a huge huge market located on Chiang Klan Road. Alpha beeta gama.",
    "rating": 4.8,
    "reviews": 21,
    "originalPrice": 5500,
    "discountedPrice": 4500,
    "priceDuration": "month",
    "wishlist": false
  },
  {
    "id": 2,
    "name": "Royal Orchid, Jaipur",
    "image": property,
    "description": "Explore the beauty of Jaipur's historic palaces and vibrant markets while enjoying luxurious stays at Royal Orchid.",
    "rating": 4.6,
    "reviews": 34,
    "originalPrice": 6000,
    "discountedPrice": 4800,
    "priceDuration": "month",
    "wishlist": true
  },
  {
    "id": 3,
    "name": "The Grand Plaza, Mumbai",
    "image": property,
    "description": "Perfect for business travelers and tourists, offering a stunning view of the city skyline.",
    "rating": 4.9,
    "reviews": 18,
    "originalPrice": 7500,
    "discountedPrice": 7000,
    "priceDuration": "month",
    "wishlist": false
  },
  {
    "id": 4,
    "name": "Leisure Inn, Goa",
    "image": property,
    "description": "Located near the serene beaches of Goa, this property provides a perfect blend of comfort and style.",
    "rating": 4.7,
    "reviews": 45,
    "originalPrice": 5000,
    "discountedPrice": 4500,
    "priceDuration": "week",
    "wishlist": true
  },
  {
    "id": 5,
    "name": "Green Valley Resort, Manali",
    "image": property,
    "description": "Nestled amidst lush greenery, this resort is perfect for those looking to unwind in nature's lap.",
    "rating": 4.5,
    "reviews": 27,
    "originalPrice": 6500,
    "discountedPrice": 6000,
    "priceDuration": "month",
    "wishlist": false
  },
  {
    "id": 6,
    "name": "Leisure Inn, Goa",
    "image": property,
    "description": "Located near the serene beaches of Goa, this property provides a perfect blend of comfort and style.",
    "rating": 4.7,
    "reviews": 45,
    "originalPrice": 5000,
    "discountedPrice": 4500,
    "priceDuration": "week",
    "wishlist": true
  },
]

export const Reviews = [
  {
    "id": 1,
    "name": "Ram Kumar Pandit",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.5,
    "reviewsCount": 2180,
    "description": "Body text for whatever you'd like to say. Add main takeaway points, quotes, anecdotes, or even a very very short story.",
    "price": 290
  },
  {
    "id": 2,
    "name": "Sanjay Mehta",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.8,
    "reviewsCount": 1540,
    "description": "A trustworthy and professional individual, always delivering high-quality service.",
    "price": 320
  },
  {
    "id": 3,
    "name": "Aarti Singh",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.2,
    "reviewsCount": 1800,
    "description": "Reliable and efficient service. Highly recommended for any tasks requiring expertise.",
    "price": 275
  },
  {
    "id": 4,
    "name": "Manoj Sharma",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.7,
    "reviewsCount": 2000,
    "description": "A dedicated professional who consistently exceeds expectations. Great value for the price.",
    "price": 310
  },
  {
    "id": 5,
    "name": "Neha Gupta",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.0,
    "reviewsCount": 1200,
    "description": "Good overall service but room for improvement in punctuality.",
    "price": 260
  },
  {
    "id": 6,
    "name": "Rajesh Verma",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.3,
    "reviewsCount": 1750,
    "description": "Professional and courteous, with an excellent understanding of customer needs.",
    "price": 290
  },
  {
    "id": 7,
    "name": "Priya Kumar",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.6,
    "reviewsCount": 2005,
    "description": "Exceptional service! Would recommend to anyone looking for reliability.",
    "price": 300
  },
  {
    "id": 8,
    "name": "Ankit Patel",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.4,
    "reviewsCount": 1500,
    "description": "Very professional and always on time. Happy with the overall service.",
    "price": 285
  },
  {
    "id": 9,
    "name": "Sunita Chauhan",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.1,
    "reviewsCount": 1600,
    "description": "Great communication and dedication to the job. Reliable and friendly.",
    "price": 270
  },
  {
    "id": 10,
    "name": "Aman Kapoor",
    "profileImage": "https://via.placeholder.com/100",
    "rating": 4.9,
    "reviewsCount": 2100,
    "description": "Top-notch service with great attention to detail. Highly satisfied!",
    "price": 350
  }
]

export const Location = [
  {
    "id": 1,
    "location": "Tokyo, Japan",
    "name": "The Shibuya",
    "image": "https://via.placeholder.com/559x646",
    "description": "A vibrant shopping and entertainment district with iconic pedestrian crossings."
  },
  {
    "id": 2,
    "location": "Paris, France",
    "name": "Eiffel Tower View",
    "image": "https://via.placeholder.com/559x646",
    "description": "Enjoy breathtaking views of the Eiffel Tower in the heart of Paris."
  },
  {
    "id": 3,
    "location": "New York, USA",
    "name": "Times Square",
    "image": "https://via.placeholder.com/559x646",
    "description": "The iconic hub of Broadway and entertainment in New York City."
  },
  {
    "id": 4,
    "location": "Rome, Italy",
    "name": "Colosseum Arena",
    "image": "https://via.placeholder.com/559x646",
    "description": "A historical marvel that captures the grandeur of ancient Rome."
  },
  {
    "id": 5,
    "location": "Sydney, Australia",
    "name": "Sydney Opera House",
    "image": "https://via.placeholder.com/559x646",
    "description": "A world-famous architectural masterpiece overlooking Sydney Harbour."
  }
]

export const blogs = [
  {
    "id": 1,
    "image": "https://via.placeholder.com/300x150?text=Temple+1",
    "date": "July 1, 2024",
    "category": "Temples & Pilgrimage",
    "title": "Kashmir’s Temples Emerge from Difficult Times Stronger than Ever",
    "description": "While not on the scale of some built by ancient kings, 6,000 temples dot the landscape, many being rebuilt with the cooperation of all communities."
  },
  {
    "id": 2,
    "image": "https://via.placeholder.com/300x150?text=Temple+2",
    "date": "June 15, 2024",
    "category": "Heritage & Culture",
    "title": "The Lost Temples of Southern India",
    "description": "Southern India boasts an array of ancient temples, with intricate carvings and fascinating histories waiting to be explored."
  },
  {
    "id": 3,
    "image": "https://via.placeholder.com/300x150?text=Temple+3",
    "date": "May 20, 2024",
    "category": "Spiritual Journeys",
    "title": "Pilgrimage to the Himalayas: A Temple Guide",
    "description": "Explore the serene beauty and spiritual significance of Himalayan temples that have stood the test of time."
  },
  {
    "id": 4,
    "image": "https://via.placeholder.com/300x150?text=Temple+4",
    "date": "April 5, 2024",
    "category": "Mythology & Legends",
    "title": "Legends of Ancient Indian Temples",
    "description": "Discover the fascinating legends and myths that surround some of India's most iconic ancient temples."
  },
  {
    "id": 5,
    "image": "https://via.placeholder.com/300x150?text=Temple+5",
    "date": "March 10, 2024",
    "category": "History & Architecture",
    "title": "Architectural Marvels: Temples of Central India",
    "description": "Central India is home to temples that reflect the region's diverse architectural heritage and cultural depth."
  }
]

export const filter = [
  {
    name: 'Sort',
    icon : filterIcon
  },
  {
    name: 'Rating',
    icon : star
  },
  {
    name: 'Amenities',
    icon : wifi
  },
  {
    name: 'Price',
    icon : rupee
  }
]


export const mobileMenu = [
  {text : "Stay", icon :faHome},
  {text : "Guide", icon :faHome},
  {text : "Home", icon :logo},
  {text : "E-puja", icon :faHome},
  {text : "Profile", icon :faHome},
]
